/**
 * Lock body scroll quand un overlay/sheet est ouvert. Empêche l'écran
 * derrière de scroller / rubber-bander sur iOS pendant qu'un modal est
 * actif.
 *
 * Utilise une simple paire `position: fixed` + restauration du scrollY,
 * pattern recommandé pour iOS (overflow:hidden seul ne suffit pas).
 */

let lockCount = 0;
let savedScrollY = 0;

export function lockBodyScroll(): void {
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  }
  lockCount += 1;
}

export function unlockBodyScroll(): void {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, savedScrollY);
  }
}
